module.exports = __webpack_public_path__ + "img/WP2023-Icon-WPseminars.30eca0f9.svg";